import { __rest } from "tslib";
import React, { useState } from 'react';
export const DropZone = (_a) => {
    var { children, onDropFiles, disabled = false, dragOverStyle = {} } = _a, passDownProps = __rest(_a, ["children", "onDropFiles", "disabled", "dragOverStyle"]);
    // We use a counter to ignore drag leave events when hovering child elements
    const [dragCounter, setDragCounter] = useState(0);
    const isDragging = dragCounter > 0;
    const dropHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const selectedFiles = Array.from(e.dataTransfer.files);
        onDropFiles(selectedFiles);
        setDragCounter(0);
    };
    const dragOverHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const dragEnterHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(dragCounter + 1);
    };
    const dragLeaveHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragCounter(dragCounter - 1);
    };
    if (disabled) {
        return React.createElement("div", Object.assign({}, passDownProps), children);
    }
    const style = isDragging ? dragOverStyle : {};
    return (React.createElement("div", Object.assign({}, passDownProps, { style: style, onDragEnter: dragEnterHandler, onDragLeave: dragLeaveHandler, onDragOver: dragOverHandler, onDrop: dropHandler }), children));
};
